import React, { useState, useEffect, useRef, Component } from 'react';
import {Input} from 'antd';

const { withGoogleMap, withScriptjs } = require('react-google-maps');
const {
  StandaloneSearchBox,
} = require('react-google-maps/lib/components/places/StandaloneSearchBox');

const API_KEY = process.env.REACT_APP_GMAP_API;

export const G_API_URL = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&v=3.exp&libraries=places&language=en`;

const Searchbox = withScriptjs(
  withGoogleMap((props) => {

    return (
      <>
        <StandaloneSearchBox
          ref={props.onSearchBoxMounted}
          onPlacesChanged={props.onPlacesChanged}
        >
          <div>
            {/* <label>Enter Address</label> */}
            <Input
              id="address-input"
              type="text"
              placeholder={props.placeholder}
              value={props.input}
              onChange={props.onChange}
              onBlur={props.onBlur}
              allowClear
              // style={{ width: '300px', 
              // padding: '10px', border: '1px solid #ccc' }}
            />
          </div>
        </StandaloneSearchBox>
      </>
    );
  })
);

const AddressField = ({
  address,
  name,
  placeholder,
  isPickupMode,
  new_factory,
  onPostalInputChange,
  onAddressInputChange,
  onBlur,
}) => {
  const searchBoxRef = useRef(null);
  const [input, setInput] = useState(address || '');
  const [newAddress, setNewAddress] = useState("");
  const [selectedPlace, setSelectedPlace] = useState({});
  const [places, setPlaces] = []
//console.log(" ------------------------ AddressField --------------", address, name, placeholder)
  useEffect(() => {
    if (address) {
      setInput(address);
    }
  }, [address]);

  const onSearchBoxMounted = (ref) => {
    searchBoxRef.current = ref;
  };

  const onPlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    const place = places[0];
    let placeObj = {};
    let formattedAddress = '';
    let postalCode = '';
    let name = place.name || '';

    if (place) {
        formattedAddress = place.formatted_address;
      
        // Check if formattedAddress contains a Plus Code (e.g., CQ75+78W) or is in a local language
        const plusCodePattern = /^[A-Za-z0-9]+[\+][A-Za-z0-9]+/; // Pattern to detect Plus Code
        const isInLocalLanguage = /[^\x00-\x7F]+/g.test(formattedAddress); // Check if there are non-ASCII characters (e.g., Bengali)
        // console.log("plusCodePattern: ", plusCodePattern,
        //   "\nisInLocalLanguage: ",isInLocalLanguage
        // );
        // If Plus Code or address is in local language, replace the first part with the 'name' from address_components
        if (plusCodePattern.test(formattedAddress) || isInLocalLanguage) {
            // console.log("formatting the address: ", formattedAddress);
            // Replace the first part before the first comma with the name
            const parts = formattedAddress.split(',');
            formattedAddress = `${name}, ${parts.slice(1).join(', ')}`;
        }

        // console.log("Updated formattedAddress: ", formattedAddress);

        setInput(formattedAddress); // Update the input with the new formatted address

        onAddressInputChange(formattedAddress, isPickupMode, new_factory);

        // Extract postal code from address components
        const addressComponents = place.address_components;
        addressComponents.forEach((component) => {
            if (component.types.includes('postal_code')) {
                postalCode = component.long_name;
            }
        });

        if (postalCode) {
            // console.log("Postal code is present.....", postalCode);
            onPostalInputChange(postalCode, isPickupMode, new_factory);
        }

        if (placeObj) {
            // console.log("placeObj: ", placeObj);
            setSelectedPlace(placeObj);
        }
    }
};

const onChange = (e) => {
  e.preventDefault();
  //console.log("-------onChange-------",e.target.value)
  setInput(e.target.value);
};

const onSetValue = (
  place_id,
  name,
  formatted_address,
  location
) => {
  // console.log("...onSetValue is executing......",place_id,name,formatted_address,location)
  setInput(formatted_address)
  setPlaces([])
  setSelectedPlace({
    place_id,
    name,
    formatted_address,
    location
  });

  setNewAddress(formatted_address)
};

  return (
    <div>
       <Searchbox
          googleMapURL={G_API_URL}
          onPlacesChanged={onPlacesChanged}
          onSearchBoxMounted={onSearchBoxMounted}
          input={input}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          placeholder = {placeholder}
          onSetValue={onSetValue}
          loadingElement={<div style={{ height: `100%`, borderRadius: `0px`  }} />}
          containerElement={<div style={{ height: `100%`, borderRadius:`0px` }} />}
          mapElement={<div style={{ height: `0%`, borderRadius: `0px` }} />}
         />
    </div>
  );
};

export default AddressField;